import { render, staticRenderFns } from "./OpportunityRegister.vue?vue&type=template&id=e2bc8382"
import script from "./OpportunityRegister.vue?vue&type=script&lang=js"
export * from "./OpportunityRegister.vue?vue&type=script&lang=js"
import style0 from "./OpportunityRegister.vue?vue&type=style&index=0&id=e2bc8382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports